import I18Next from "../../Control/Vue/I18Next";
import { MiaPlaza } from "../../Reinforced.Typings";
import { HandlerType } from "../base/HandlerType";
import { prompt, type PromptInstance } from "./../../Control/Vue/Notifications/Prompts";

export class FeatureLevelSelect implements HandlerType {
	private previousValue?: string;
	private fullSocialPrompt?: PromptInstance<boolean>;
	private hasUserRespondedToPrompt: boolean = false;

	constructor(private select: JQuery) {
		select.change(this.onChange.bind(this));

		const currentValue = select.val() as string;
		this.updatePreviousValue(currentValue);
	}

	private async onChange(event: JQuery.ChangeEvent) {
		const select = jQuery(event.target);
		const currentValue = select.val() as string;

		if (this.fullSocialPrompt) {
			this.fullSocialPrompt.hide();
		}

		if (currentValue === MiaPlaza.Model.FeatureAccessLevel.FullSocial && !this.hasUserRespondedToPrompt) {
			this.fullSocialPrompt = prompt(this.select.data("full-social-message"),[
				{ label: I18Next.tr("OkCancel_Ok"), value: true },
				{ label: I18Next.tr("OkCancel_Cancel"), value: false }
			]);

			const isConfirmed = await this.fullSocialPrompt.promise;
			this.hasUserRespondedToPrompt = true;

			if (isConfirmed) {
				this.updatePreviousValue(currentValue);
				jQuery(document).trigger("featureLevelChange", currentValue);
			}
			else {
				if (this.previousValue !== undefined) {
					select.val(this.previousValue);
				}
				select.trigger("change");
			}
		}
		else {
			jQuery(document).trigger("featureLevelChange", currentValue);
			this.updatePreviousValue(currentValue);
		}
	}

	private updatePreviousValue(newValue: string) {
		this.previousValue = newValue;
	}
}
